// コメントの投稿時刻を相対表記（たった今 / N分前 / N時間前 / N日前）で表す。
// 7 日以上前は JST の日付（YYYY/MM/DD）で表示する（ローカル運用メモに従い JST 表記・"JST" 文字は付けない）。

/**
 * ISO8601 文字列を相対時刻ラベルへ変換する。
 * @param iso 投稿時刻（ISO8601）
 * @param now 比較基準（既定は現在時刻）。テスト用に差し替え可能。
 */
export function formatCommentTimestamp(iso: string, now: Date = new Date()): string {
  const t = Date.parse(iso);
  if (!Number.isFinite(t)) return "";
  const diffSec = Math.floor((now.getTime() - t) / 1000);
  // 端末時計のずれ等で未来時刻になっても破綻しないよう「たった今」に丸める。
  if (diffSec < 60) return "たった今";
  const min = Math.floor(diffSec / 60);
  if (min < 60) return `${min}分前`;
  const hour = Math.floor(min / 60);
  if (hour < 24) return `${hour}時間前`;
  const day = Math.floor(hour / 24);
  if (day < 7) return `${day}日前`;
  return formatJstDate(t);
}

/** ツールチップ等で使う、JST の絶対時刻（YYYY/MM/DD HH:mm）。 */
export function formatCommentAbsolute(iso: string): string {
  const t = Date.parse(iso);
  if (!Number.isFinite(t)) return "";
  return new Intl.DateTimeFormat("ja-JP", {
    timeZone: "Asia/Tokyo",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).format(new Date(t));
}

function formatJstDate(epochMs: number): string {
  return new Intl.DateTimeFormat("ja-JP", {
    timeZone: "Asia/Tokyo",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(new Date(epochMs));
}
